// 必須引入 Ionic 的核心 CSS
import '@ionic/vue/css/core.css'
// 選擇性地引入其他 Ionic 全域樣式
import '@ionic/vue/css/normalize.css'
import '@ionic/vue/css/structure.css'
import '@ionic/vue/css/typography.css'
import '@ionic/vue/css/display.css'
import '@ionic/vue/css/flex-utils.css'

import { createApp } from 'vue'
import App from './App.vue'
import { changeLocale, I18nPlugin, UILangEnum } from '@shared-i18n'
import {
    IonCol,
    IonContent,
    IonGrid,
    IonHeader,
    IonIcon,
    IonicVue,
    IonImg,
    IonInput,
    IonModal,
    IonPage,
    IonPopover,
    IonRange,
    IonRow,
    IonSelect,
    IonSelectOption,
    IonToolbar,
} from '@ionic/vue'
import { LocalStoragePlugin, PiniaPlugin } from '@shared-plugin'
// 配置路由
import router from './router'
import { getLocalStorage, setLocalStorage } from '@ipevo-rd/service-web-utils'
import { StorageKeyEnum } from '@shared-common'

// 取得 App instance
const app = createApp(App)

// 配置LocalStorage全域方法
app.use(LocalStoragePlugin)

// 配置 i18n 全局方法
app.use(I18nPlugin)

// 取得當前設定語言，如果沒有設定，則預設為英文
let lang = getLocalStorage(StorageKeyEnum.UILang) as UILangEnum || null
// 介面語言沒有被設定的話
if (!lang) {
    // 取得使用者的瀏覽器語言設定
    lang = navigator.language || navigator.userLanguage
    // 取得所有支援的語言值
    const allUILangValues = Object.values(UILangEnum)

    // 瀏覽器語言不在支援的語言列表中
    if (!allUILangValues.includes(lang)) {
        //則預設為英文
        lang = UILangEnum.English
    }

    // 設定當前語言到 localStorage
    setLocalStorage(StorageKeyEnum.UILang, lang)
}
// 設定UI當前語言
changeLocale(lang)

// 配置 Pinia 狀態管理
app.use(PiniaPlugin)

// 配置Ionic
app.use(IonicVue)
app.component('IonContent', IonContent)
app.component('IonSelect', IonSelect)
app.component('IonSelectOption', IonSelectOption)
app.component('IonInput', IonInput)
app.component('IonPage', IonPage)
app.component('IonCol', IonCol)
app.component('IonGrid', IonGrid)
app.component('IonIcon', IonIcon)
app.component('IonRow', IonRow)
app.component('IonImg', IonImg)
app.component('IonModal', IonModal)
app.component('IonHeader', IonHeader)
app.component('IonToolbar', IonToolbar)
app.component('IonPopover', IonPopover)
app.component('IonRange', IonRange)

// 註冊自有組件
import { LoadingPage, NavigationBar } from '@shared-components'

app.component('NavigationBar', NavigationBar)
app.component('LoadingPage', LoadingPage)

/**
 * 設定除錯模式
 */
import { useInfoStore } from '@shared-store'
// 取得設定Debug模式的方法
const { setIsDevMode } = useInfoStore()
// 將Debug模式設定為網頁刷新時設定false
setIsDevMode(false)

// 配置路由
app.use(router)
// Mount the app
app.mount('#root')
